import { createFileRoute } from '@tanstack/react-router';

import { preLoadDefaultProject } from '@/lib/queries/project';

import { GrafanaForm } from './-components/GrafanaForm';

export const Route = createFileRoute(
  '/_root/integrations/monitoring/grafana/new',
)({
  component: RouteComponent,
  loader: async ({ context }) => {
    return preLoadDefaultProject({ context });
  },
});

function RouteComponent() {
  const mainProject = Route.useLoaderData();

  return <GrafanaForm mainProject={mainProject} />;
}
